import { render, staticRenderFns } from "./MobileCustomer.vue?vue&type=template&id=015c5296&scoped=true&lang=pug&"
import script from "./MobileCustomer.vue?vue&type=script&lang=js&"
export * from "./MobileCustomer.vue?vue&type=script&lang=js&"
import style0 from "./MobileCustomer.vue?vue&type=style&index=0&id=015c5296&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015c5296",
  null
  
)

component.options.__file = "MobileCustomer.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VExpansionPanel } from 'vuetify/lib'
import { VExpansionPanelContent } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VAutocomplete,
  VBtn,
  VContainer,
  VExpansionPanel,
  VExpansionPanelContent,
  VFlex,
  VForm,
  VIcon,
  VLayout,
  VList,
  VListTile,
  VSelect,
  VSwitch,
  VTextField,
})
